import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RELOAD_CONFIGURATION } from "../../store/actions/configurationActions";
import { getSessionIdSafe } from "../../store/sagas/selectors";
import { configuration } from "../../api/client/SdsWebApiClient";
import { useSignalR } from "../../hooks/useSignalR";
import { useRemoteControlEnabled } from "../../hooks/useRemoteControlEnabled";

/**
 * Side-effect-only component that manages SignalR updates for remote control.
 */
export const RemoteControlListener: React.FC = () => {
    const dispatch = useDispatch();
    const sessionId = useSelector(getSessionIdSafe);
    const showRemoteControlLink = useRemoteControlEnabled();

    // Use same base as API (service_url or origin); normalize so SignalR hub path is correct
    const rawBase = configuration.basePath || window.location.origin;
    const baseUrl = rawBase ? rawBase.replace(/\/+$/, "") : "";
    const signalREnabled = showRemoteControlLink && !!sessionId && !!baseUrl;

    const handleConfigurationChanged = useCallback(() => {
        dispatch({ type: RELOAD_CONFIGURATION });
    }, [dispatch]);

    useSignalR({
        url: baseUrl,
        sessionId: sessionId || "",
        onConfigurationChanged: handleConfigurationChanged,
        enabled: signalREnabled,
    });

    return null;
};
